import { InjectionToken } from "@angular/core";

/** Define the scroll behavior (need to be defined to "instant" in unit test) */
export const AUTOSCROLL_BEHAVIOR = new InjectionToken<ScrollBehavior>("AUTOSCROLL_BEHAVIOR", {
  factory: () => "smooth",
});
